// Third-party
import React from 'react';
import { connect } from 'react-redux';

// Redux
import { ReduxState } from '../../../redux/modules/types';
import { openNotificationCenter } from '../../../redux/modules/announcements/user';

// Utils
import { PERMISSIONS, userHasPermission } from '../../../utils/permissions';
import { FormattedMessage } from '../../../utils/i18n';

// Components
import { Button } from '../../components/buttons';
import Nullable from '@/types/nullable';
import User from '@/types/user';

type DispatchProps = {
  openNotificationCenter: () => void;
};

type StateProps = {
  unacknowledgedCount: number;
  user?: Nullable<User>;
};

type Props = DispatchProps & StateProps;

class AnnouncementBanner extends React.Component<Props> {
  render() {
    const { unacknowledgedCount, user } = this.props;

    if (!unacknowledgedCount || !userHasPermission(user, PERMISSIONS.NOTIFICATION_CENTER)) {
      return null;
    }

    return (
      <div className="announcement-banner">
        <i className="icon-exclamation" />
        <FormattedMessage id="AnnouncementBanner.Message" values={{ count: unacknowledgedCount }} />
        <Button onClick={this.props.openNotificationCenter} className="open-notification-center">
          <FormattedMessage id="AnnouncementBanner.Button" />
        </Button>
      </div>
    );
  }
}

const mapStateToProps = (state: ReduxState): StateProps => ({
  unacknowledgedCount: state.userAnnouncements.unacknowledgedCount,
  user: state.auth.user,
});

export default connect(mapStateToProps, { openNotificationCenter })(AnnouncementBanner);
